var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "../valueObjects/guid", "../../localDateUtil"], function (require, exports, guid_1, localDateUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PrintHelper = void 0;
    guid_1 = __importDefault(guid_1);
    var PrintHelper = (function () {
        function PrintHelper(elementId) {
            this.printClass = 'print-cofiguration';
            this.elementId = elementId || (new guid_1.default()).toString();
        }
        PrintHelper.prototype.setClassOnElement = function (element, className, value) {
            var classList = element.classList;
            if (value)
                classList.add(className);
            else
                classList.remove(className);
        };
        PrintHelper.prototype.setPrintClass = function (value) {
            this.setClassOnElement(document.documentElement, this.printClass, value);
            this.setClassOnElement(document.body, this.printClass, value);
        };
        PrintHelper.prototype.getElement = function () {
            return document.getElementById(this.elementId);
        };
        PrintHelper.prototype.createAndAddElement = function () {
            var el = document.createElement('div');
            el.id = this.elementId;
            document.body.prepend(el);
            this.setPrintClass(true);
        };
        PrintHelper.prototype.elementExists = function () {
            return (this.getElement() != null);
        };
        PrintHelper.prototype.setPrintContent = function (html) {
            if (!this.elementExists())
                this.createAndAddElement();
            this.getElement().innerHTML = html;
            return this;
        };
        PrintHelper.prototype.print = function () {
            window.print();
            return this;
        };
        PrintHelper.prototype.removePrintContent = function () {
            if (this.elementExists())
                document.body.removeChild(this.getElement());
            this.setPrintClass(false);
            return this;
        };
        PrintHelper.printContent = function (html, keepContentUntilAfterPrint) {
            if (keepContentUntilAfterPrint === void 0) { keepContentUntilAfterPrint = false; }
            var _printHelper = new PrintHelper();
            try {
                _printHelper.setPrintContent(html);
                localDateUtil_1.formatDocumentToLocalDate(_printHelper.elementId);
                if (!keepContentUntilAfterPrint) {
                    _printHelper.print();
                    return;
                }
                var cleaned_1 = false;
                var cleanup_1 = function () {
                    if (cleaned_1)
                        return;
                    cleaned_1 = true;
                    window.removeEventListener('afterprint', cleanup_1);
                    _printHelper.removePrintContent();
                };
                window.addEventListener('afterprint', cleanup_1);
                _printHelper.print();
                window.setTimeout(cleanup_1, 3000);
            }
            finally {
                if (!keepContentUntilAfterPrint)
                    _printHelper.removePrintContent();
            }
        };
        return PrintHelper;
    }());
    exports.PrintHelper = PrintHelper;
});
